const ProjectList = {
  "21001_CASA-FARO": {
    id: "21001_CASA-FARO",
    title: "CASA FARO",
    publish: false,
    location: "JOSE IGNACIO",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: true,
    description:
      "Casa Faro es un proyecto que surge de la renovación de una vivienda construida, parte de la cual se utilizaba para oficinas y el resto estaba en desuso. Se reutilizó la parte en desuso para colocar el área privada y se le agregó un volumen social diseñado como contraste de lo existente, con grandes aberturas al patio, potenciando la relación con el exterior. La interfaz entre lo viejo y lo nuevo se resuelve con un núcleo húmedo que pivotea entre las dos construcciones resolviendo los servicios de la casa.",
    usage: "VIVIENDA",
    year: 2021,
    constructionArea: "150 M2",
    reach: null,
    status: "CONSTRUIDO",
    photography: "JUAN PABLO PULETTO",
  },
  "24001_SIERRA": {
    id: "24001_SIERRA",
    title: "CASA EN LA SIERRA",
    publish: true,
    location: "SIERRA DE MINAS",
    galleryImageName: "24001_SIERRA_04",
    bannerImageName: "24001_SIERRA_06",
    showInHomePage: true,
    description:
      "Casa en la Sierra es una obra pensada en armonía con el lugar. Se utilizó una explanada existente en el terreno evitando movimientos de tierra, se construyó con piedra del mismo terreno y se ejecutó con piedreros de la zona. Toda la obra se resume en cinco muros de piedra de tres metros de altura que potencian la experiencia del paisaje, generando primero el suspenso y luego el encuadre del paisaje serrano. La horizontalidad del proyecto contrasta con la ondulación del paisaje haciendo que ambos luzcan sus virtudes. ",
    usage: "VIVIENDA",
    year: 2024,
    constructionArea: "80 M2",
    reach: null,
    status: "CONSTRUIDO",
    photography: "JUAN PABLO PULETTO",
  },
  "25018_LOCALES-FARO": {
    id: "25018_LOCALES-FARO",
    title: "LOCALES FARO",
    publish: true,
    location: "JOSE IGNACIO",
    galleryImageName: "25018_LOCALES-FARO_01",
    bannerImageName: "25018_LOCALES-FARO_01",
    showInHomePage: true,
    description:
      "Locales Faro se divide en dos locales comerciales diseñados para poder convertirse en oficinas o apartamentos. A esta flexibilidad se le agrega una capa extra, dandole características distintas a cada planta. La planta baja se diseña muy vinculada con el exterior a traves de una piel de vidrio de piso a techo, y la planta alta se diseña pensando en espacios mas íntimos, los cuales aprovechan las vistas pero se resguardan de las visuales del exterior a través de parasoles y celosías que ademas controlan la luz solar.",
    usage: "CENTRO COMERCIAL",
    year: 2025,
    constructionArea: "540 M2",
    reach: null,
    status: "EN OBRA",
    photography: null,
  },
  "25019_ASTRA": {
    id: "25019_ASTRA",
    title: "CLUBHOUSE ASTRA",
    publish: true,
    location: "PUNTA BALLENA",
    galleryImageName: "25019_ASTRA_01",
    bannerImageName: "25019_ASTRA_01",
    showInHomePage: true,
    description:
      "Astra es un proyecto donde varios programas se resuelven en un mismo elemento. En este proyecto se resuelve el acceso al barrio, un espacio de usos multiples, un gimnasio, un spa y el area de mantenimiento, todo en un mismo edificio articulado de forma tal que cada espacio se viva con total independencia. Esto hace a la cubierta la protagonista del proyecto, una cubierta de madera que en contraste con el entorno natural se destaca por su simpleza y presencia bajo la cual suceden todas las actividades del barrio.",
    usage: "ACCESO Y CLUBHOUSE",
    year: 2025,
    constructionArea: "300 M2",
    reach: null,
    status: "EN OBRA",
    photography: null,
  },
  "25039_AUE04": {
    id: "25039_AUE04",
    title: "CASA AUE04",
    publish: true,
    location: "BARRIO AURA",
    galleryImageName: "25039_AUE04_02",
    bannerImageName: "25039_AUE04_01",
    showInHomePage: true,
    description:
      "AUE04 es una casa en la que se busca la entrada de sol del norte de forma constante a todos los espacios de la casa. Para lograrlo se coloca un gran vacío central que permite la entrada de luz solar desde el norte al área social que se encuentra conectada con el patio que da al sur. Este vacío se materealiza en vidrio y se le coloca una escalera helicoidal escultórica que hace de ese vacío central un conector y un patio que ofician de interfaz entre todos los espacios de la casa. ",
    usage: "VIVIENDA",
    year: 2025,
    constructionArea: "550 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "25036_ASD17": {
    id: "25036_ASD17",
    title: "CASA ASD17",
    publish: true,
    location: "BARRIO ASTRA",
    galleryImageName: "25036_ASD17_02",
    bannerImageName: "25036_ASD17_02",
    showInHomePage: true,
    description:
      "ASD17 es un proyecto implantado en un terreno en primera línea al mar con desniveles hacia la costa y vista al mar al sur. Por esto se resuelve generar un patio interno que permita que la casa mire hacia el sur pero le ingrese luz solar desde el norte. Se colocan los espacios mas importantes de la casa detrás de este patio para lograr tener vistas al mar y los espacios de servicio por delante mirando hacia la calle. El desnivel se aprovecha para lograr un subsuelo hacia la playa en la que se colocan las áreas recreativas de gimnasio, spa, cava y parrillero.",
    usage: "VIVIENDA",
    year: 2025,
    constructionArea: "700 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "24002_ATELIER-PM151": {
    id: "24002_ATELIER-PM151",
    title: "ATELIER PM151",
    publish: true,
    location: "BARRIO PUEBLO MIO",
    galleryImageName: "24002_ATELIER-PM151_05",
    bannerImageName: "24002_ATELIER-PM151_01",
    showInHomePage: true,
    description:
      "El Atelier Soldano es una obra que fusiona las necesidades espaciales de la artista, las visuales al exterior, la entrada de luz y la exposición de arte. Para lograr esta fusión el elemento toma una forma especial, con ángulos abiertos que hacen que el proyecto mire hacia donde debe, muros equipados para hacerlo funcional, ventanales que sirven de espacios de exposición y parasoles que controlan la luz solar. Las fachadas se componen con materiales que conecten el elemento nuevo con la vivienda existente, armonizando el conjunto.",
    usage: "ATELIER",
    year: 2024,
    constructionArea: "50 M2",
    reach: null,
    status: "CONSTRUIDO",
    photography: "JUAN PABLO PULETTO",
  },
  "26002_NP03": {
    id: "26002_NP03",
    title: "CASA NP03",
    publish: true,
    location: "BARRIO NATIVO",
    galleryImageName: "26002_NP03_01",
    bannerImageName: "26002_NP03_01",
    showInHomePage: true,
    description:
      "NP03 es una casa que pretende resaltar por su simplicidad, no solo volumétrica sino también constructiva. Esta pensada para resolver toda su estructura en hormigón armado visto, grandes ventanales y muros de piedra que articulan los espacios y sirven de apoyos visuales de la cubierta. Su planta en U esta pensada para resguardar el área de parrillero y piscina exterior de los vientos de la zona para poder disfrutar de los exteriores con el mayor confort posible.",
    usage: "VIVIENDA",
    year: 2026,
    constructionArea: "300 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "25037_EONA": {
    id: "25037_EONA",
    title: "EONA",
    publish: true,
    location: "PUNTA DEL ESTE",
    galleryImageName: "25037_EONA_01",
    bannerImageName: "25037_EONA_01",
    showInHomePage: true,
    description:
      "Eona es un centro de alto rendimiento deportivo diseñado para dar respuesta a las necesidades actuales y a futuro que puedan existir para entrenar y rehabilitar a deportistas de alto nivel. El proyecto esta pensado de manera flexible, dando muchas posibilidades de futuras subdivisiones interiores. En este proyecto se prioriza la funcionalidad y la conexión con la naturaleza, generando un patio central que permita dar luz a todo el espacio pero también permitir vistas al verde a los deportistas en su recuperación o entrenamiento.",
    usage: "CENTRO DEPORTIVO",
    year: 2025,
    constructionArea: "570 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "25015_DMN12": {
    id: "25015_DMN12",
    title: "CASA DMN12",
    publish: true,
    location: "BARRIO DON MIGUEL",
    galleryImageName: "25015_DMN12_02",
    bannerImageName: "25015_DMN12_01",
    showInHomePage: false,
    description:
      "DMN12 es un proyecto que se resuelve en forma de U generando no solo un gran jardín central protegido del viento sino también un espacio de fuerte conexión entre los usuarios de la casa. Se divide en tres volumenes, un volúmen de living, comedor y cocina, un volúmen de dormitorios y un volúmen con playroom, parrillero y dormitorio de visitas. Estos volumenes se unen por conectores con espacios ajardinados que permiten siempre recorrer la casa en vínculo con el verde.",
    usage: "VIVIENDA",
    year: 2025,
    constructionArea: "200 M2",
    reach: null,
    status: "EN OBRA",
    photography: null,
  },
  "24004_LCB9": {
    id: "24004_LCB9",
    title: "CASA LCB9",
    publish: true,
    location: "BARRIO LA CAÑADA",
    galleryImageName: "24004_LCB09_01",
    bannerImageName: "24004_LCB09_02",
    showInHomePage: true,
    description:
      "LCB09 es una casa desarrollada en un terreno en esquina con vistas al lago hacia el norte. La planta baja se coloca de forma que toda el área social quede orientada hacia el jardín, permitiendo una conexión franca entre el interior y el exterior. Por el otro lado, la planta alta se coloca rotada con respecto a la planta baja, logrando asi que no solo todos los dormitorios queden con luz del norte sino también que tengan vista al lago.",
    usage: "VIVIENDA",
    year: 2024,
    constructionArea: "300 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "25009_LA-CUCHILLA": {
    id: "25009_LA-CUCHILLA",
    title: "CASA LA CUCHILLA",
    publish: true,
    location: "SAN CARLOS",
    galleryImageName: "25009_LA-CUCHILLA_01",
    bannerImageName: "25009_LA-CUCHILLA_01",
    showInHomePage: false,
    description:
      "Casa La Cuchilla se encuentra en una chacra rural y busca aprovechar las vistas desde todos los espacios de la casa. Para esto se piensa una planta lineal, con la circulación interior orientada hacia el camino, permitiendo que desde el living hasta los baños tengan vistas hacia el campo. Esta estategia no solo conecta a toda la casa con esas visuales encuadradas en cada ventana sino que también le da privacidad de las vistas desde el camino público.",
    usage: "VIVIENDA",
    year: 2025,
    constructionArea: "140 M2",
    reach: null,
    status: "EN OBRA",
    photography: null,
  },
  "25008_LCK15": {
    id: "25008_LCK15",
    title: "CASA LCK15",
    publish: true,
    location: "BARRIO LA CAÑADA",
    galleryImageName: "25008_LCK15_01",
    bannerImageName: "25008_LCK15_01",
    showInHomePage: false,
    description:
      "Casa LCK15 te recibe con un gran hall de acceso en doble altura que jerarquiza la entrada y hace entrar luz a toda la casa. Se aprovecha el desnivel del terreno para generar un subsuelo para el garage y la sala de maquinas, y toda la casa se articula a traves de un solo núcleo de escaleras que te distribuye a todos los espacios de la casa. Los aleros de fachada buscan marcar el desarrollo en tres plantas y contrastar con el desnivel del terreno remarcarcando el juego con el desnivel para generar los espacios.",
    usage: "VIVIENDA",
    year: 2025,
    constructionArea: "320 M2",
    reach: null,
    status: "EN OBRA",
    photography: null,
  },
  "25001_RYF": {
    id: "25001_RYF",
    title: "CASA RYF",
    publish: true,
    location: "PUNTA DEL ESTE",
    galleryImageName: "25001_RYF_01",
    bannerImageName: "25001_RYF_01",
    showInHomePage: false,
    description:
      "En la Casa RyF el volúmen social se jerarquiza por su altura, con dos grandes ventanales que conectan al living con el jardín por un lado y la luz del norte por el otro, permitiendo al interior bañarse de luz durante todo el año. El acceso une al área social y al área privada, abriendose también hacia el jardín, generando un hall desde el que acceder a todas las areas de la casa. El volúmen privado esta diseñado para poder ampliarse en un futuro dependiendo de las necesidades de la familia.",
    usage: "VIVIENDA",
    year: 2025,
    constructionArea: "140 M2",
    reach: null,
    status: "CONSTRUIDO",
    photography: "JUAN PABLO PULETTO",
  },
  "25020_TI-MANANTIALES": {
    id: "25020_TI-MANANTIALES",
    title: "TI MANANTIALES",
    publish: false,
    location: "MANANTIALES",
    galleryImageName: "25020_TI-MANANTIALES_01",
    bannerImageName: "25020_TI-MANANTIALES_01",
    showInHomePage: false,
    description:
      "TI Manantiales es un proyecto de uso mixto, con un gran local comercial en planta baja pensado para poder dividirse de acuerdo a las necesidades y seis apartamentos en planta alta con su azotea privada. Los apartamentos se piensan para ser vividos como casas, ubicando la escalera para la azotea dentro de la unidad para asi cada unidad puede tener su patio exterior privado. Diseñamos la baranda para poder aislar ese patio de la actividad en planta baja y disfrutar de la vista al mar y el cielo de Manantiales.",
    usage: "COMERCIAL Y VIVIENDA",
    year: 2025,
    constructionArea: "1400 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "23001_GIM-CCT": {
    id: "23001_GIM-CCT",
    title: "GIMNASIO CCT",
    publish: false,
    location: "TRINIDAD",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "GIMNASIO",
    year: 2023,
    constructionArea: "80 M2",
    reach: null,
    status: "CONSTRUIDO",
    photography: null,
  },
  "23002_OBRADOR-RM": {
    id: "23002_OBRADOR-RM",
    title: "OBRADOR RESERVA MONTOYA",
    publish: false,
    location: "BARRIO RESERVA MONTOYA",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "OBRADOR",
    year: 2023,
    constructionArea: "300 M2",
    reach: null,
    status: "CONSTRUIDO",
    photography: "JUAN PABLO PULETTO",
  },
  "25007_AMPLIACION-MC": {
    id: "25007_AMPLIACION-MC",
    title: "AMPLIACIÓN MC",
    publish: false,
    location: "PUNTA DEL ESTE",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "VIVIENDA",
    year: 2025,
    constructionArea: "60 M2",
    reach: null,
    status: "CONSTRUIDO",
    photography: "JUAN PABLO PULETTO",
  },
  "25004_GALPONES-LK": {
    id: "25004_GALPONES-LK",
    title: "GALPONES LA KAZONA",
    publish: false,
    location: "MALDONADO",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "DEPÓSITO",
    year: 2025,
    constructionArea: "700 M2",
    reach: null,
    status: "EN OBRA",
    photography: null,
  },
  "25002_REFORMA-DIAZ": {
    id: "25002_REFORMA-DIAZ",
    title: "REFORMA DIAZ",
    publish: false,
    location: "JOSE IGNACIO",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "OFICINA",
    year: 2025,
    constructionArea: "120 M2",
    reach: null,
    status: "CONSTRUIDO",
    photography: null,
  },
  "25003_OFICINA-INTERFAZ": {
    id: "25003_OFICINA-INTERFAZ",
    title: "OFICINA INTERFAZ",
    publish: false,
    location: "MANANTIALES",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "OFICINA",
    year: 2025,
    constructionArea: "60 M2",
    reach: null,
    status: "CONSTRUIDO",
    photography: "JUAN PABLO PULETTO",
  },
  "25012_LA-MORENITA": {
    id: "25012_LA-MORENITA",
    title: "AMENITIES LA MORENITA",
    publish: false,
    location: "JOSE IGNACIO",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "ACCESO Y CLUBHOUSE",
    year: 2025,
    constructionArea: "30 M2",
    reach: null,
    status: "EN OBRA",
    photography: "JUAN PABLO PULETTO",
  },
  "25005_D52": {
    id: "25005_D52",
    title: "D52",
    publish: false,
    location: "PUNTA DEL ESTE",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "CENTRO DE SALUD",
    year: 2025,
    constructionArea: "3000 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "24003_LIBERTAD": {
    id: "24003_LIBERTAD",
    title: "CIUDAD DEPORTIVA LIBERTAD",
    publish: false,
    location: "SAN CARLOS",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "CENTRO DEPORTIVO",
    year: 2023,
    constructionArea: null,
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "25014_SAN-JUAN-DEL-ESTE": {
    id: "25014_SAN-JUAN-DEL-ESTE",
    title: "SAN JUAN DEL ESTE",
    publish: false,
    location: "BALNEARIO BUENOS AIRES",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "CENTRO COMERCIAL",
    year: 2025,
    constructionArea: "3000 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "25010_VINAS-DEL-FARO": {
    id: "25010_VINAS-DEL-FARO",
    title: "BODEGA VIÑAS DEL FARO",
    publish: false,
    location: "JOSE IGNACIO",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "BODEGA",
    year: 2025,
    constructionArea: "2500 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "26007_LCH17": {
    id: "26007_LCH17",
    title: "CASA LCH17",
    publish: false,
    location: "BARRIO LA CAÑADA",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "VIVIENDA",
    year: 2026,
    constructionArea: "180 M2",
    reach: null,
    status: "EN OBRA",
    photography: null,
  },
  "25011_CENTRO-VITAL": {
    id: "25011_CENTRO-VITAL",
    title: "CENTRO VITAL",
    publish: false,
    location: "PUNTA DEL ESTE",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: true,
    description: null,
    usage: "CENTRO PARA ADULTOS MAYORES",
    year: 2025,
    constructionArea: "1100 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "25006_PUEBLA": {
    id: "25006_PUEBLA",
    title: "PUEBLA",
    publish: false,
    location: "SAN CARLOS",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "VIVIENDA",
    year: 2025,
    constructionArea: "500 M2",
    reach: null,
    status: "EN OBRA",
    photography: null,
  },
  "25030_LA-CHOZA-HOMES": {
    id: "25030_LA-CHOZA-HOMES",
    title: "LA CHOZA HOMES",
    publish: false,
    location: "ARENAS DE JOSE IGNACIO",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "VIVIENDA",
    year: 2025,
    constructionArea: "1500 M2",
    reach: null,
    status: "EN OBRA",
    photography: null,
  },
  "26013_RM155": {
    id: "26013_RM155",
    title: "CASA RM155",
    publish: false,
    location: "BARRIO RESERVA MONTOYA",
    galleryImageName: "26013_RM155_01",
    bannerImageName: "26013_RM155_01",
    showInHomePage: false,
    description: null,
    usage: "VIVIENDA",
    year: 2026,
    constructionArea: "280 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "25022_NS10": {
    id: "25022_NS10",
    title: "CASA NS10",
    publish: false,
    location: "BARRIO NATIVO",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "VIVIENDA",
    year: 2025,
    constructionArea: "400 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "25023_CMD10": {
    id: "25023_CMD10",
    title: "CASA CMD10",
    publish: false,
    location: "BARRIO NATIVO",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "VIVIENDA",
    year: 2025,
    constructionArea: "340 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "25026_MARINA": {
    id: "25026_MARINA",
    title: "MARINA BEACH HOUSING",
    publish: false,
    location: "MARINA BEACH",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "VIVIENDA",
    year: 2025,
    constructionArea: "2000 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "25033_NL06": {
    id: "25033_NL06",
    title: "CASA NL06",
    publish: false,
    location: "BARRIO NATIVO",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "VIVIENDA",
    year: 2025,
    constructionArea: "350 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "25034_OBRADOR-LA-LINDA": {
    id: "25034_OBRADOR-LA-LINDA",
    title: "OBRADOR LA LINDA",
    publish: false,
    location: "EL CHORRO",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "OBRADOR ",
    year: 2025,
    constructionArea: "180 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "25038_GALERIA-DIAZ": {
    id: "25038_GALERIA-DIAZ",
    title: "GALERIA DIAZ",
    publish: false,
    location: "JOSE IGNACIO",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "GALERIA",
    year: 2025,
    constructionArea: "450 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "26001_ANASTASIO": {
    id: "26001_ANASTASIO",
    title: "CASA ANASTASIO",
    publish: false,
    location: "JOSE IGNACIO",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: true,
    description: null,
    usage: "VIVIENDA",
    year: 2026,
    constructionArea: "300 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "26004_JYF": {
    id: "26004_JYF",
    title: "AMPLIACIÓN JYF",
    publish: false,
    location: "PUNTA DEL ESTE",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "VIVIENDA",
    year: 2026,
    constructionArea: "80 M2",
    reach: null,
    status: "EN OBRA",
    photography: null,
  },
  "26006_LP25": {
    id: "26006_LP25",
    title: "CASA LP25",
    publish: false,
    location: "CHACRAS LA PLANTACIÓN",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "VIVIENDA",
    year: 2026,
    constructionArea: "500 M2",
    reach: null,
    status: "EN OBRA",
    photography: null,
  },
  "26008_VINA-EDEN": {
    id: "26008_VINA-EDEN",
    title: "CLUBHOUSE VIÑA EDEN",
    publish: false,
    location: "VIÑA EDEN",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "CLUBHOUSE",
    year: 2026,
    constructionArea: "500 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "26010_CDL": {
    id: "26010_CDL",
    title: "CASA CDL",
    publish: false,
    location: "CLUB DEL LAGO",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "VIVIENDA",
    year: 2026,
    constructionArea: "180 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "26014_EL-JAGUEL": {
    id: "26014_EL-JAGUEL",
    title: "AERODROMO EL JAGUEL",
    publish: false,
    location: "PUNTA DEL ESTE",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "AERODROMO",
    year: 2026,
    constructionArea: "2500 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "24005_LA-VIUDA": {
    id: "24005_LA-VIUDA",
    title: "WINE LODGE LA VIUDA",
    publish: false,
    location: "LA RIOJA",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "HOTEL",
    year: 2024,
    constructionArea: "400 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
  "26011_MANANTIALES": {
    id: "26011_MANANTIALES",
    title: "LOCALES MANANTIALES",
    publish: false,
    location: "MANANTIALES",
    galleryImageName: null,
    bannerImageName: null,
    showInHomePage: false,
    description: null,
    usage: "CENTRO COMERCIAL",
    year: 2026,
    constructionArea: "250 M2",
    reach: null,
    status: "EN PROYECTO ",
    photography: null,
  },
};

export default ProjectList;
